import { InternetUseCase } from '../InternetCalculatorInterfaces';
const isDevicesCount = (value) => {
    return ['1', '3', '5', '10', '20', '30'].includes(value);
};
const TECHNOLOGY_ORDER = ['XGS-PON', 'GPON', 'VDSL35B', 'VDSL2', '5GNR', 'LTE'];
export const REGULAR_INTERNET_USE_CASES = [
    InternetUseCase.SURFING,
    InternetUseCase.STREAMING,
    InternetUseCase.VIDEOCALLS,
    InternetUseCase.GAMING,
];
export const SECURE_NET_USE_CASES = [
    InternetUseCase.SMALL_DEVICES,
    InternetUseCase.SECURE_NET_VIDEO_CALLS,
    InternetUseCase.SECURE_NET_SURFING,
    InternetUseCase.HIGH_SPEED_WORK,
];
export const SECURE_NET_MOBILE_USE_CASES = [
    InternetUseCase.SMALL_DEVICES,
    InternetUseCase.SECURE_NET_SURFING,
    InternetUseCase.SECURE_NET_VIDEO_CALLS,
    InternetUseCase.HIGH_SPEED_WORK,
];
export const internetSuggestSpeedCalculatorDefaultState = {
    selectedDevices: '',
    selectedUseCases: [],
    suggestedOffer: '',
};
const sortByTechnology = (a, b) => {
    const techA = a === null || a === void 0 ? void 0 : a.technology;
    const techB = b === null || b === void 0 ? void 0 : b.technology;
    const indexA = TECHNOLOGY_ORDER.indexOf(techA);
    const indexB = TECHNOLOGY_ORDER.indexOf(techB);
    if (indexA === -1 && indexB === -1) {
        return 0;
    }
    else if (indexA === -1) {
        return 1;
    }
    else if (indexB === -1) {
        return -1;
    }
    else {
        return indexA - indexB;
    }
};
const findBestTechnology = (offers) => {
    const teliaOfa = offers.find((o) => o.technology === 'GPON' && !o.properties.includes('PARTNER'));
    if (teliaOfa) {
        return teliaOfa.productOfferingCode;
    }
    return offers.sort(sortByTechnology)[0].productOfferingCode;
};
export const findClosestMatch = (speed, offers) => {
    const availableSpeeds = offers.filter((offer) => !offer.properties.includes('LIABLE_ONLY_FOR_SALES_CONSULTANT')).map((offer) => +offer.downloadSpeed);
    if (!(availableSpeeds === null || availableSpeeds === void 0 ? void 0 : availableSpeeds.length) || !speed) {
        return '';
    }
    const bestMatch = availableSpeeds.reduce((prev, curr) => {
        return Math.abs(curr - speed) < Math.abs(prev - speed) || prev <= 5 ? curr : prev;
    });
    const suggestedOffers = offers.filter((offer) => +offer.downloadSpeed === bestMatch);
    if (suggestedOffers.length === 1) {
        return suggestedOffers[0].productOfferingCode;
    }
    return findBestTechnology(suggestedOffers);
};
export const selectedUseCasesContainSmallDevices = (selectedUseCases) => {
    return selectedUseCases.includes(InternetUseCase.SMALL_DEVICES);
};
const resolveDeviceScore = (config, state) => {
    var _a;
    const selectedDevices = isDevicesCount(state.selectedDevices) ? state.selectedDevices : config.defaultDevices;
    return (_a = config === null || config === void 0 ? void 0 : config.deviceScores) === null || _a === void 0 ? void 0 : _a[selectedDevices];
};
const resolveUseCaseCountScale = (config, selectedUseCases) => {
    return selectedUseCases.length * (config === null || config === void 0 ? void 0 : config.useCaseCountScale) + 1;
};
const resolveUseCaseScore = (config, selectedUseCases, deviceScore) => {
    let useCaseScore = 1;
    selectedUseCases.forEach((value) => { var _a; return (useCaseScore += ((_a = config === null || config === void 0 ? void 0 : config.useCaseScores) === null || _a === void 0 ? void 0 : _a[value]) * deviceScore); });
    return useCaseScore;
};
export const calculateSuggestion = (state, offers, config) => {
    if (!(offers === null || offers === void 0 ? void 0 : offers.length) || (!state.selectedUseCases.length && !state.selectedDevices)) {
        return '';
    }
    const selectedUseCases = state.selectedUseCases.length ? state.selectedUseCases : config.defaultUseCases;
    const deviceScore = resolveDeviceScore(config, state);
    const useCaseCountScale = resolveUseCaseCountScale(config, selectedUseCases);
    const useCaseScore = resolveUseCaseScore(config, selectedUseCases, deviceScore);
    const devicesScale = config === null || config === void 0 ? void 0 : config.deviceScale;
    const useCaseScale = config === null || config === void 0 ? void 0 : config.useCaseScale;
    if (!selectedUseCases.includes(InternetUseCase.SMALL_DEVICES)) {
        offers = offers.filter((offer) => !offer.properties.includes('HIDDEN_SECURE_NET_OFFER'));
    }
    if (!isDevicesCount(state.selectedDevices) && selectedUseCases.includes(InternetUseCase.SMALL_DEVICES) && selectedUseCases.length === 1) {
        const suggestedSpeed = 20;
        return findClosestMatch(suggestedSpeed, offers);
    }
    const suggestedSpeed = Math.round(devicesScale * deviceScore * (useCaseScale * useCaseScore) * useCaseCountScale * 1000);
    return findClosestMatch(suggestedSpeed, offers);
};
